<template>
  <a-card :title="title">
    <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="{span: 4}" :wrapper-col="{span: 18}">
      <div class="section-title">基本信息</div>
      <a-row>
        <a-col :span="12">
          <a-form-model-item label="模板名称" prop="name">
            <a-input v-model.trim="form.name" allowClear placeholder="请输入" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="模板类型" prop="template_type">
            <a-select v-model="form.template_type" option-filter-prop="children" allowClear show-search placeholder="请选择" @change="handleTemplateTypeChange" style="width: 100%">
              <a-select-option v-for="item in TEMPLATE_TYPE" :key="item.key" :value="item.key">{{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="发布平台" prop="line_id">
            <a-select v-model="form.line_id" option-filter-prop="children" allowClear show-search placeholder="请选择" style="width: 100%">
              <a-select-option v-for="item in platformList" :key="item.id" :value="Number(item.id)">{{ item.org }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="模板状态" prop="state">
            <a-radio-group v-model="form.state" name="radioGroup">
              <a-radio v-for="item in TEMPLATE_STATE" :key="item.key" :value="item.key">{{ item.value }}</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <div class="field-info">
        <span class="field-info-title">字段信息</span>
        <a-button class="btn" type="primary" :disabled="notChoosedTemplate" @click="openPickFieldsModal" icon="plus-circle">选择字段</a-button>
        <span class="notice" v-show="notChoosedTemplate">请先选择模板类型</span>
      </div>
      <a-row>
        <!-- <a-table bordered row-key="field" :columns="columns" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange}" :data-source="data" :pagination="false"> -->
        <a-table id="sTable" bordered row-key="field" :columns="columns" :data-source="data" :pagination="false">
          <!-- 是否必填 -->
          <template slot="must" slot-scope="text, record">
            <a-radio-group v-model="record.must" name="radioGroup">
              <a-radio v-for="item in TEMPLATE_FIELD_MUST" :key="item.key" :value="item.key">{{ item.value }}</a-radio>
            </a-radio-group>
          </template>
          <!-- 字段备注 -->
          <template slot="field_remark" slot-scope="text, record">
            <!-- 模板类型为：案例，字段备注取值特殊 -->
            <template v-if="form.template_type == 3">
              {{ getFieldRemark(record) }}
            </template>
            <template v-else>
              {{ text }}
            </template>
          </template>
          <template slot="field_tip" slot-scope="text, record">
            <a-input v-model.trim="record.field_tip" allowClear :maxLength="20" placeholder="请输入提示文字，不超过20字" />
          </template>
          <template slot="sort">
            <a-icon type="drag" class="sort-icon"/>
          </template>
          <template slot="action" slot-scope="text, record">
            <a-button type="text" @click="removeItem(record)">移除</a-button>
          </template>
        </a-table>
      </a-row>
      <a-row style="margin-top: 20px">
        <a-col span="24">
          <a-form-model-item :wrapper-col="{span: 20, offset: 1}">
            <a-button :loading="submitLoading" class="mr20" type="primary" @click="handleSubmit" :disabled="data.length<1">保 存</a-button>
            <a-button @click="$router.go(-1)">取 消</a-button>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>

    <pickFields ref="pickFields" :allFields="allFields" @ok="getPickFields" />
  </a-card>
</template>
<script>
import { pick, cloneDeep } from 'lodash'
import { reactive, onMounted, toRefs, computed, getCurrentInstance, watch } from '@vue/composition-api'
import { form, rules, columns, getFieldRemark } from './business/constant'
import compuedFun from './computed/'
import api from '@/api/'
import pickFields from './components/Template/pickFields.vue'
import Sortable from "sortablejs"

const title = {
  Add: '添加模板',
  Edit: '编辑模板',
}

export default {
  name: 'EditTemplate',
  components: { pickFields },
  setup(props) {
    const _this = getCurrentInstance()

    const Id = computed(() => _this.$route.params.id)
    // 是否可以添加模板字段
    const notChoosedTemplate = computed(() => !state.form.template_type)

    const state = reactive({
      form: { ...form },
      data: [],
      rules,
      columns,
      selectedRowKeys: [],
      platformList: [], // 发布平台
      originPlatformList: [],
      title: Id.value ? title.Edit : title.Add,
      submitLoading: false,
      allFields: []
    })

    onMounted(async () => {
      await methods.getPlatform()
      if (Id.value) {
        await methods.getFiledsDetail()
      }
      methods.getFileds()
      methods.initSortable()
    })

    const methods = {
      getFieldRemark,
      initSortable() {
        new Sortable(document.querySelector("#sTable tbody"), {
          handle: ".ant-table-row .sort-icon",
          animation: 150,
          ghostClass: "blue-background-class",
          sort: true,
          onEnd({ newIndex, oldIndex }) {
            const currRow = state.data.splice(oldIndex, 1)[0]
            state.data.splice(newIndex, 0, currRow)
          },
        })
      },
      handleTemplateTypeChange() {
        state.data = []
        return methods.getFileds()
      },
      // 获取发布平台列表
      async getPlatform() {
        const res = await api.LineListNew()
        state.originPlatformList = res?.data || []
        state.platformList = res.data.filter((item) => {
          if (item.parent_id === 0) {
            return item
          }
        })
      },
      async getFiledsDetail() {
        const res = await api.detailTemplate({ id: Id.value })
        if (_this.$validate(res)) {
          const data = res.data.template
          const _formData = pick.apply(undefined, [data].concat(Object.keys(state.form)))
          state.form = { ...state.form, ..._formData }
          state.form.line_id = this.getFirstLine(state.form.line_id)
          state.data = data.templateField
        }
      },
      getFirstLine(id) {
        const find_parent = state.originPlatformList.find(item => Number(item.id) === Number(id))
        if (find_parent) {
          if (Number(find_parent?.parent_id) === 0) {
            return Number(find_parent.id)
          } else {
            return this.getFirstLine(find_parent.parent_id)
          }
        }
      },

      async getFileds() {
        const template_type = state.form.template_type
        if (template_type) {
          const res = await api.fieldListTemplate({ template_type: state.form.template_type })
          const { templateField } = res.data
          // state.data = templateField
          // 字段来源：《字段管理》页面 “字段所属 = 当前模板类型” 且 “状态 = 启用” 的字段
          state.allFields = templateField
        } else {
          state.allFields = []
        }
      },

      onSelectChange(selectedRowKeys) {
        this.selectedRowKeys = selectedRowKeys
      },

      handleSubmit() {
        let selectList = []
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            if (!state.data.length) {
              return this.$message.warning(' 至少需要添加一条字段信息！')
            }
            let res = null
            this.submitLoading = true

            selectList = state.data.map(({ field, field_type, field_name, field_remark, must, field_tip, label }, index) => {
              return { field, field_type, field_name, field_remark, must, field_tip, label, sort: index + 1 }
            })

            const data = Object.assign({}, state.form, { template_field: selectList })
            if (Id.value) {
              res = await api.updateTemplate(data)
            } else {
              res = await api.createTemplate(data)
            }
            this.submitLoading = false
            if (_this.$validate(res)) {
              this.$message.success(Id.value ? '编辑成功~' : '添加成功~')
              _this.$router.push('/template/list')
            }
          } else {
            this.$message.warning('请检查信息是否填写完成')
          }
        })
      },

      removeItem(record) {
        state.data = state.data.filter(item => item.field !== record.field)
      },

      openPickFieldsModal() {
        const defaultFields = state.data.map(item => item.field)
        this.$refs.pickFields.showModal(defaultFields)
      },

      getPickFields(chooseFields) {
        const chooseRecords = this.allFields.filter(item => chooseFields.includes(item.field))
        if (state.data.length === 0) {
          state.data = cloneDeep(chooseRecords)
        } else {
          const hisData = state.data.filter(item => chooseRecords.some(f => f.field === item.field))
          const newData = chooseRecords.filter(f => !state.data.some(item => item.field === f.field))
          state.data = [...cloneDeep(hisData), ...cloneDeep(newData)]
        }
      }
    }

    return {
      ...toRefs(state),
      ...compuedFun(),
      Id,
      notChoosedTemplate,
      ...methods,
    }
  },
}
</script>

<style lang="less" scoped>
.section-title,
.field-info-title {
  font-size: 20px;
  font-weight: 800;
  padding: 20px 0;
}

.field-info {
  padding: 20px 0;
  display: flex;
  align-items: center;

  .btn {
    margin: 0 15px;
  }

  .notice {
    font-size: 14px;
    color: #999;
  }
}

.sort-icon {
  cursor: pointer;
  font-size: 16px;
  &:hover {
    color: #1890ff
  }
}

</style>
<style>
.blue-background-class {
  background-color: #e6f7ff;
}
</style>
